import { Pipe, PipeTransform } from '@angular/core';
export class OffsetArrayPipe implements PipeTransform {
/**
 * @param {?} items
 * @param {?} arr
 * @param {?} offset
 * @param {?} limit
 * @return {?}
 */
transform(items: any[], arr: number, offset: number, limit: number) {
    if (!items && !arr && !offset && !limit) return [];

    const /** @type {?} */ data = ( /** @type {?} */((<any>Object))).assign([], arr);

    const /** @type {?} */ ret = data.splice(offset, limit);

    return ret;
  }
static decorators: DecoratorInvocation[] = [
{ type: Pipe, args: [{
  name: 'tnkOffsetArray',
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

function OffsetArrayPipe_tsickle_Closure_declarations() {
/** @type {?} */
OffsetArrayPipe.decorators;
/**
 * @nocollapse
 * @type {?}
 */
OffsetArrayPipe.ctorParameters;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
